export const BillingPlan = {
	FREE: 'trial',
	STARTUP: 'startup',
	RECRUITER: 'recruiter',
	PAID: 'paid',
	ENTERPRISE: 'enterprise',
	EXPIRED: 'free',
	PENDING: 'pending approval'
} as const;
